import { render, staticRenderFns } from "./draft-set.vue?vue&type=template&id=73ee6a17&"
import script from "./draft-set.vue?vue&type=script&lang=js&"
export * from "./draft-set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports